import { setContext } from '@apollo/client/link/context';

export const createTimeZoneLink = () => setContext((_, { headers }) => ({
  headers: {
    ...headers,
    'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
}));
